// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import _, { get, merge, find } from 'lodash';
import { push } from 'react-router-redux';
import phoneify from 'phoneify';
import {lookup} from '../../../../redux/helpers/staticData';

@connect((store, props) => ({
  user: store.user,
  staticData: store.staticData,
}))
export default class JobRequestAlertDetail extends Component {

  static propTypes = {
    user: PropTypes.object.isRequired,
    detail: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired
  }

  render() {

    let {detail, staticData} = this.props;

    return (

        <div clasName='job-request-alert-detail'>
         <div className='alert-contact-info'>
               <div data-id='selected-action'>A new Job Request was submitted by:</div>
         </div> 
         <br />
         <div className='alert-additional-info'>
               <div className='notification-link'
                data-id='selected-name'
                onClick={(e) => this.props.dispatch(push(`/admin/contacts/${detail.profile.id}/details`))}>
                  {detail.user.firstName} {detail.user.lastName}
              </div>
              <div data-id='selected-title'>{detail.profile.title}</div>
              <div data-id='selected-company-name'>{detail.company.name}</div>
              <div data-id='selected-phone'>{detail.user.phoneNumber1 && phoneify(detail.user.phoneNumber1).countryCodeRemoved.addTrailingSlashes}</div>
              <div data-id='selected-email'>{detail.user.email}</div>
              <div data-id='selected-position-title'>{ lookup(staticData, 'positionTypes', detail.positionTypeId) }</div>
            </div>           
          </div>

    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Alerts/JobRequestAlertDetail/index.js